import { Routes, CanDeactivate } from '@angular/router';
import { LoginFormComponent } from './components/UI/login-form/login-form.component';
import { SplashComponent } from './components/shared/splash/splash.component';
import { SubscriptionErrorComponent } from './components/subscription-error/subscription-error.component';
import { ResetPasswordComponent } from './components/UI/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './components/UI/forgot-password/forgot-password.component';
import { InventoryDashboardComponent } from './components/UI/inventory-dashboard/inventory-dashboard.component';
import { ReportsDashboardComponent } from './components/UI/reports-dashboard/reports-dashboard.component';
import { CostCalculatorComponent } from './components/UI/cost-calculator/cost-calculator.component';
import { CostingDashboardComponent } from './components/UI/costing-dashboard/costing-dashboard.component';
import { BusinessFormComponent } from './components/UI/business-details/business-form.component';
import { ManufacturingSupplyChainDashboardComponent } from './components/UI/manufacturing-supply-chain-dashboard/manufacturing-supply-chain-dashboard.component';
import { RegistrationComponent } from './components/UI/registration/registration.component';
import { AlertComponent } from './components/shared/reusables/alert/alert.component';
import { ConfigComponent } from './components/UI/config/config.component';
import { RenewalModalComponent } from './components/shared/renewal-modal/renewal-modal.component';
import { MainDashboardComponent } from './components/UI/main-dashboard/main-dashboard.component';
import { SetupGuard } from './guards/setup.guard';
import { AccountTypeGuard } from './guards/account-type.guard';
import { AuthGuard } from './guards/auth.guard';
import { MobileGuard } from './guards/mobile.guard';
export const routes: Routes = [
  { path: 'login', component: LoginFormComponent, data: { title: 'Login' } },
  { path: '', component: LoginFormComponent, data: { title: 'Login' } },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: { title: 'Forgot Password' },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { title: 'Reset Password' },
  },
  {
    path: 'dashboard',
    component: MainDashboardComponent,
    data: { title: 'Main Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'inventory',
    component: InventoryDashboardComponent,
    data: { title: 'Inventory Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },

  {
    path: 'calc',
    component: CostCalculatorComponent,
    data: { title: 'Cost Calculator' },
    canActivate: [AuthGuard, SetupGuard],
    canDeactivate: [
      (component: CostCalculatorComponent) => component.canDeactivate(),
    ],
  },
  {
    path: 'reports',
    component: ReportsDashboardComponent,
    data: { title: 'Reports Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'costing',
    component: CostingDashboardComponent,
    data: { title: 'Costing & Budgeting Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'business-details',
    component: BusinessFormComponent,
    data: { title: 'Business Details' },
    canActivate: [AuthGuard],
  },
  {
    path: 'manufacturing',
    component: ManufacturingSupplyChainDashboardComponent,
    data: { title: 'Manufacturing & Supply Chain' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'register',
    component: RegistrationComponent,
    data: { title: 'Registration' },
  },
  { path: 'alert', component: AlertComponent, data: { title: 'alert' } },
  {
    path: 'config',
    component: ConfigComponent,
    data: { title: 'Configurations' },
    canActivate: [AuthGuard],
  },
  {
    path: 'subscription-error',
    component: SubscriptionErrorComponent,
    data: { title: 'Subscription Error' },
  },
  {
    path: 'renewal',
    component: RenewalModalComponent,
    data: { title: 'Subscription Renewal' },
  },
];
